export const blockIconsAndroidWallpaperNew = (
	<span className='material-symbols-outlined'>wallpaper</span>
);
